
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { Project_Activity, Public_Project_Details } from "@/generated/graphql";
  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";
  import CardBodySingleChip from "@/components/card/CardBodySingleChipNew.vue";
  import ItemChipsData from "@/entities/ItemChipsData";
  import Tooltip from "@/components/common/Tooltip.vue";
  import TooltipVariants from "@/entities/TooltipVariants";

  interface ActivityTooltip {
    title: string,
    classes: string
  }

  @Component({
    components: {
      Tooltip,
      CardBodySingleChip,
    }
  })
  export default class ReviewDetails extends Vue {
    @Prop({ type: Object, required: true }) readonly projectDetails!: Public_Project_Details;
    @Prop({ type: Object, default: undefined }) readonly projectActivity?: Project_Activity;

    TooltipVariants = TooltipVariants;

    get activityTooltip(): ActivityTooltip {
      if (this.projectDetails.activity_deleted) {
        return {
          title: "This task has been removed",
          classes: "w-36",
        };
      }

      return {
        title: "You do not have access to this project task",
        classes: "w-48",
      };
    }

    get activityTooltipDisabled(): boolean {
      return Boolean(this.projectActivity?.id);
    }

    get projectAccessTooltipDisabled(): boolean {
      return Boolean(this.projectDetails?.project?.id) ;
    }

    get activityChipDetails(): ItemChipsData {
      return {
        id: this.projectActivity?.id,
        name: this.projectDetails.activity_title!,
        routeParams: this.activityRouteParams!,
      };
    }

    get projectChipDetails(): ItemChipsData {
      return {
        id: this.projectId!,
        name: this.projectDetails.project_name!,
        routeParams: this.projectRouteParams,
      };
    }

    get projectId(): string | undefined {
      return this.projectDetails.project?.id;
    }

    get projectRouteParams(): RouteParams<{ id: string }> {
      return {
        name: RouteNames.PROJECT_ACTIVITY,
        params: {
          id: this.projectId!,
        },
      };
    }

    get activityRouteParams(): RouteParams<{ id: string }> | undefined {
      if (!this.projectActivity) {
        return;
      }

      return this.projectRouteParams;
    }
  }
